export default __webpack_public_path__ + "static/media/Gloves of the Deathstalker.392bd76f.jpg";